import { Button, Card, CardBody } from "@heroui/react";
import { TOOLBAR_ITEMS } from "@/features/notes/config";
import { ToolbarItemSetting } from "@/services/api/fetchers/user-settings";

interface ToolbarPreviewProps {
  className?: string;
  items: ToolbarItemSetting[];
}

export function ToolbarPreview({ items, className }: ToolbarPreviewProps) {
  return (
    <Card className={className}>
      <CardBody className="flex flex-row justify-center p-0">
        <div className="flex min-h-12 max-w-max flex-row items-center gap-1 overflow-x-auto p-2">
          {items.some((item) => item.enabled) ? (
            items.map((toolbarItemSetting) => {
              if (!toolbarItemSetting.enabled) return null;

              const toolbarItem = TOOLBAR_ITEMS.find((item) => item.id === toolbarItemSetting.id);
              if (!toolbarItem) return null;

              return (
                <Button
                  key={toolbarItemSetting.id}
                  isDisabled
                  isIconOnly
                  variant="light"
                  size="sm"
                  title={toolbarItem.label}
                >
                  {toolbarItem.icon}
                </Button>
              );
            })
          ) : (
            <p className="text-default-500 text-sm">No toolbar items enabled</p>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
